import FreeText from '@algbra/ui/components/FreeText/FreeText'
import { Container } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { resolveAsImage } from '@algbra/ui/resolvers'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import styles from './BorderlessPlan.module.scss'
import { ReactComponent as InfoIcon } from '../../images/info.svg'

export type BorderlessPlanListItemProps = {
  title: string
  description: string
  value: string
}
export type BorderlessPlanListProps = {
  title: string
  logoImage: GatsbyResolvedAsset
  borderlessPlanListItem: BorderlessPlanListItemProps[]
}
export type ZoneBorderlessPlanProps = {
  __typename: 'StrapiGQL_ComponentZonesBorderlessPlan'
  id: string
  borderlessPlanTitle: string
  description: string
  footnote: string
  borderlessPlanList?: BorderlessPlanListProps[]
}

export default function ZoneBorderlessPlan({
  id,
  borderlessPlanTitle,
  description,
  footnote,
  borderlessPlanList,
}: ZoneBorderlessPlanProps): JSX.Element {
  return (
    <Whitespace type="lg" className={styles.whitespace}>
      <Container>
        <div className={styles.wrapper}>
          <div className={styles.container}>
            <Heading type="lg" className={styles.title}>
              {borderlessPlanTitle}
            </Heading>
            <FreeText type="md" innerHTML={description} className={styles.text}>
              {description}
            </FreeText>

            <div className={styles.listWrapper}>
              {borderlessPlanList?.map((item, index) => (
                <div className={styles.listContainer} key={item.title + index}>
                  <div className={styles.listTitleBlock}>
                    <GatsbyImage
                      image={resolveAsImage(item.logoImage)}
                      alt={item.title}
                      className={styles.listLogo}
                    />
                    <div className={styles.listContent}>
                      <FreeText
                        innerHTML={item.title}
                        className={styles.listTitle}
                      >
                        {item.title}
                      </FreeText>
                    </div>
                  </div>
                  {item.borderlessPlanListItem?.map((listItem, listIndex) => (
                    <div
                      className={styles.listItemWrapper}
                      key={listItem.title + listIndex}
                    >
                      <div
                        className={classNames(styles.listItem, {
                          [styles.noBorder]:
                            listIndex ===
                            item.borderlessPlanListItem.length - 1,
                        })}
                      >
                        <div>
                          <FreeText
                            innerHTML={listItem.title}
                            className={styles.listItemTitle}
                          >
                            {listItem.title}
                          </FreeText>
                          <FreeText
                            innerHTML={listItem.description}
                            className={styles.listItemDescription}
                          >
                            {listItem.description}
                          </FreeText>
                        </div>
                        <div>
                          <FreeText
                            innerHTML={listItem.value}
                            className={styles.listItemValue}
                          >
                            {listItem.value}
                          </FreeText>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>

            <div className={styles.footnoteWrapper}>
              <InfoIcon />
              <FreeText innerHTML={footnote} className={styles.footnote}>
                {footnote}
              </FreeText>
            </div>
          </div>
        </div>
      </Container>
    </Whitespace>
  )
}
